// app theme preset color
export const appThemeList: string[] = [
  '#005293',
  '#2d8cf0',
  '#0960bd',
  '#0084f4',
  '#009688',
  '#536dfe',
  '#ff5c93',
  '#ee4f12',
  '#0096c7',
  '#9c27b0',
  '#ff9800',
  '#FF3D68',
  '#00C1D4',
  '#71EFA3',
  '#171010',
  '#78DEC7',
  '#1768AC',
  '#FB9300',
  '#FC5404',
  '#FF4848',
  '#2C2E43',
  '#66DE93',
  '#0A1D37',
  '#39A6A3',
  '#FF8474',
];

const setting = {
  //深色主题
  darkTheme: false,
  //系统主题色
  appTheme: '#005293', // #2d8cf0
  //系统内置主题色列表
  appThemeList,
};

export default setting;
